import { Navigate, Route, Routes as RRRoutes } from 'react-router-dom';

import ReviewBoard from '../pages/ReviewBoard';
import TimeTracking from '../pages/TimeTracking';
import Capacity from '../pages/Capacity';
import AdminOverview from '../pages/AdminOverview';
import ClientDetail from '../pages/ClientDetail';
import UserDetail from '../pages/UserDetail';
import Settings from '../pages/Settings';
import ExcessExportDownload from '../pages/ExcessExportDownload';

export function Routes() {
  return (
    <RRRoutes>
      <Route path="/" element={<ReviewBoard />} />
      <Route path="/time-tracking" element={<TimeTracking />} />
      <Route path="/capacity" element={<Capacity />} />
      <Route path="/admin" element={<AdminOverview />} />
      <Route path="/admin/clients/:id" element={<ClientDetail />} />
      <Route path="/admin/users/:id" element={<UserDetail />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/exports/:id" element={<ExcessExportDownload />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </RRRoutes>
  );
}
